<!--<app-client-portal-header></app-client-portal-header>-->

<div class="register-client-container">
  <!-- span spacer -->
  <span></span>
  <div class="grid-cont register-client-container__card">
    <div class="login">
      <aiwyn-logo [height]="60" [extraClasses]="'mb--200 login__logo'"></aiwyn-logo>

      <div class="block login__cont">
        <div class="grid-row grid-row--jcc">
          <div class="grid-col grid-col--auto">
            <button type="button" class="mb--125 button button--simple" (click)="goBack()">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="button__icon">
                <line x1="19" y1="12" x2="5" y2="12"></line>
                <polyline points="12 19 5 12 12 5"></polyline>
              </svg>
              <span>Go back</span></button>
          </div>
        </div>
        <div>
          <h2 class="mb--075">Welcome to {{ configService.customerName }}</h2>
          <span>Finish setting up access for {{ userEmail }}</span>

          <form
            *ngIf="!(isFormLoading$ | async) && registerContactForm; else spinnerTemplate"
            data-private
            name="registerContactForm"
            (ngSubmit)="submit()"
            [formGroup]="registerContactForm"
          >
            <ng-container *ngIf="registerContactForm.controls.fullName">
              <div class="ta--left">Full Name</div>
              <input type="text" name="fullName" #fullName formControlName="fullName" class="form-input mt-1" data-cy="full-name">
              <mat-error *ngIf="(registerContactForm.controls.fullName.errors && (registerContactForm.controls.fullName.touched || registerContactForm.controls.fullName.dirty))">
                Please enter your name
              </mat-error>
            </ng-container>

            <ng-container *ngIf="registerContactForm.controls.clientKey">
              <div class="mt-2 ta--left">{{ clientKeyLabel }}</div>
              <input type="text" name="clientKey" #clientKey formControlName="clientKey" class="form-input mt--025" data-cy="client-key">
              <mat-error *ngIf="(registerContactForm.controls.clientKey.errors && (registerContactForm.controls.clientKey.touched || registerContactForm.controls.clientKey.dirty))">
                Please enter {{ clientKeyLabel }}
              </mat-error>
              <mat-error *ngIf="!clientKeyValid">
                The {{ clientKeyLabel }} entered is either not valid or the client is inactive
              </mat-error>
              <mat-hint>This can be found on a recent invoice</mat-hint>

              <div *ngIf="configService.invoiceNoClientKeyGuestLogin && !configService.relaxedModeEnabled">
                <div class="mt-2 ta--left">Invoice Number</div>
                <input type="text" name="invoiceNumber" #invoiceNumber formControlName="invoiceNumber" class="form-input mt--025">
                <mat-error *ngIf="(registerContactForm.controls.invoiceNumber.errors && (registerContactForm.controls.invoiceNumber.touched || registerContactForm.controls.invoiceNumber.dirty))">
                  Please enter an Invoice Number
                </mat-error>
                <mat-hint>Enter an invoice number from any invoice you’ve ever received for this client. If you have never received an invoice for this client, leave this field blank.</mat-hint>
              </div>
            </ng-container>

            <div *ngIf="configService.relaxedModeEnabled">
              <div class="mt--050 ta--left">Client Name</div>
              <input type="text" name="clientName" #clientName formControlName="clientName" class="form-input mt--025">
              <div class="tc--xlight ta--left mt--025">Enter in the name of the organization you are paying on behalf of.</div>
              <mat-error *ngIf="(registerContactForm.controls.clientName.errors && (registerContactForm.controls.clientName.touched || registerContactForm.controls.clientName.dirty))">
                Please enter a Client Name
              </mat-error>
            </div>

            <ng-container *ngIf="registerContactForm.controls.terms">
              <div style="display:block; text-align: left;">
                <mat-checkbox formControlName="terms" class="mt-4 group-500" data-cy="terms-and-conditions">
                  Agree to Aiwyn's
                  <a class="inline-link" data-cy="terms-and-conditions-link" (click)="legalService.openTermsAndConditions()">Terms of Service</a>
                  and
                  <a class="inline-link" data-cy="privacy-policy-link" (click)="legalService.openPrivacyPolicy()">Privacy Policy</a>
                </mat-checkbox>
                <mat-error *ngIf="(registerContactForm.controls.terms.errors && (registerContactForm.controls.terms.touched || registerContactForm.controls.terms.dirty))">
                  Please accept the Terms and Conditions to continue
                </mat-error>
              </div>
            </ng-container>

            <div class="mt--100 grid-row grid-row--jcc">
                <button
                  type="submit"
                  andButton
                  color="primary"
                  size="large"
                  class="w-100 mt-6"
                  data-cy="submit"
                  [isLoading]="isSubmissionProcessing$ | async"
                >
                  Submit
                </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngIf="!(isUserFullyRegistered$ | async)">
        Already have an account?
        <span class="text-link" (click)="signOut()">Sign in with a different email address.</span>
      </div>
    </div>

    <app-full-client-portal-footer class="mt-8"></app-full-client-portal-footer>
  </div>

  <div></div>
</div>

<ng-template #spinnerTemplate>
  <div class="d-flex justify-content-center mt-8">
    <mat-spinner size="100"></mat-spinner>
  </div>
</ng-template>
